import { useTranslation } from 'react-i18next'
import { Section } from '#app/ui/components/custom/section'
import {
	Avatar,
	AvatarFallback,
	AvatarImage,
} from '#app/ui/components/media/avatar'

export const Testimonial = () => {
	const { t } = useTranslation('home')

	return (
		<Section className="scroll-mt-24" id="testimonial">
			<figure className="mx-auto max-w-2xl rounded-2xl border border-hairline bg-surface p-6 sm:p-8 md:p-10">
				<blockquote className="text-balance text-fluid-lg font-medium leading-relaxed text-foreground">
					“{t('testimonial.quote')}”
				</blockquote>
				<figcaption className="mt-fluid-12 flex items-center gap-4">
					<Avatar className="h-12 w-12">
						<AvatarImage src="/img/biel-martinez.jpg" alt={t('testimonial.name')} />
						<AvatarFallback>BM</AvatarFallback>
					</Avatar>
					<div className="min-w-0">
						<p className="font-medium text-foreground">
							{t('testimonial.name')}
						</p>
						<p className="text-sm text-muted-600">{t('testimonial.role')}</p>
					</div>
				</figcaption>
			</figure>
		</Section>
	)
}
